import { ADD_PLAYER }  from 'state/types';

export const addPlayerAction = {
    STARTED: (player: any) => ({ type: ADD_PLAYER.STARTED, payload: player }),
    FULLFILLED: (results: any) => ({ type: ADD_PLAYER.FULLFILLED, payload: results }),
    REJECTED: () => ({ type: ADD_PLAYER.REJECTED })
  };
  